import { connect } from 'react-redux';

import { getItemsList } from '../../Items/itemsActions';
import { getOfficesShortList } from '../../Offices/officesActions';
import CampReadiness from './CampReadiness';
import { getCampReadinessDashboardData } from './CampReadinessActions';

const mapStateToProps = state => ({
  officesShortList: state.office.officesShortList,
  itemsList: state.items.itemsList,
  campReadinessDashboardData: state.dashboard.campReadinessDashboardData,
  isLoading: state.dashboard.campReadinessIsLoading,
});
const mapDispatchToProps = dispatch => ({
  getOfficesShortList: params => dispatch(getOfficesShortList(params)),
  getItemsList: params => dispatch(getItemsList(params)),
  getCampReadinessDashboardData: params =>
    dispatch(getCampReadinessDashboardData(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CampReadiness);
